
<template>
    <modal
        name="showCommentModal"
        classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
        :reset="true" width="450px" height="auto"
      >
        <div class="v-modal">
          <div class="popup-header fromDetailsPage">
            <h2 class="popup-title">{{approveType?'Approve':'Reject'}}</h2>
            <span @click="hideMe()">
              <em class="material-icons">close</em> 
            </span>
          </div>
          <form data-vv-scope="submittForm" @submit.prevent @keydown.enter.prevent>
          <div class="form-container">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="form_group">
                        <quillTextEditor :display="true" :wrapclass="''" :formscope="'submittForm'" v-model="commentData" :fieldName="'commentData'"  :required="approveType?false:true"  :customValidNotRequire="false" :label="'Comments'" :placeHolder="'Comments'"  :canSpellCheck="true"/>
                    </div>
                </div>
            </div>
          </div>
          <div class="popup-footer relative">
            <vs-button color="dark" @click="hideMe(false)" class="cancel" type="filled">Cancel</vs-button>
            <vs-button color="success" @click="submitForm()" class="save" type="filled">Submit</vs-button>
          </div>
        </form>
          </div>
      </modal> 
    </template>
    <script>
    import quillTextEditor from"@/views/forms/fields/quillTextEditor.vue";
    export default {
      inject: ["parentValidator"],
      created() {
          this.$validator = this.parentValidator;
      },
      methods: {
        submitForm() {
            this.$validator.validateAll("submittForm").then((result) => {
                if (result) {
                    this.hideMe(true, this.commentData)
                }
            });
        },
        hideMe(callFromSubmit=false, comment='') {
          this.$emit("hideCommentPopup", callFromSubmit, comment );
          this.$modal.hide('showCommentModal');
        },
      },
      watch: {
        
      },
      mounted() {
        this.commentData = '';
        this.$modal.show('showCommentModal');
      },
      data: () => ({
        commentData:'',
      }),
      props: {
        petitionDetails: {
          type: Object,
          default: null,
        },
        approveType:{
            type: Boolean,
            default: false,
        }
      },
    components: {
        quillTextEditor,
    },
    };
    </script>